export type Testimonial = {
  quote: string
  author: string
  role: string
  /** Photo URL, only with the person's permission. Empty = initials. */
  avatar?: string
  /** Star rating, only if the person actually gave one. */
  rating?: number
}

/**
 * Reviews supplied by the product owner. Keep them word-for-word, with
 * permission, and free of claims about behavior, memory or health.
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I like having three ways to run the same activity. It gives me flexibility to adapt the session to different participation levels.',
    author: 'Sarah Mitchell',
    role: 'Activities Coordinator, Memory Care',
  },
  {
    quote:
      'The step-by-step format makes it easier to prepare an activity and offer different ways for residents to take part.',
    author: 'Jennifer Brooks',
    role: 'Life Enrichment Director',
  },
  {
    quote:
      'I appreciate that I can use familiar materials while following a clear structure for the activity.',
    author: 'Michael Turner',
    role: 'Memory Care Activities Director',
  },
  {
    quote:
      'I can use the same activity with a group or adapt it for a one-on-one visit. That flexibility is helpful in my daily planning.',
    author: 'Rebecca Wilson',
    role: 'Lifestyle Coordinator',
  },
]

export const moreTestimonials: Testimonial[] = []
